import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { checkValidForm } from './Step1';
import { useEffect } from 'react';
import BtnSave from './BtnSave';

const Step4 = (props) => {
    const { t } = useTranslation();

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep4(true);
            })
            .catch(() => props.setStep4(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.marketingAdvertising) {
            onValuesChange(null, props.previewData?.marketingAdvertising);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = ['marketingActivityTh'];
        const check = checkValidForm(fields, allValues);
        props.setStep4(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('policy.des4')}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="marketingAdvertising"
                layout="vertical"
                form={props?.form}
            >
                <Form.Item
                    className="mt-4"
                    name={'marketingActivityTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.marketingActivityTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'marketingActivityEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.marketingActivityEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodEnPl')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step4;
